import React from "react";
import Chart from "react-apexcharts";
import { Spin } from "antd";
import EmptyBox from "../../../ui/EmptyBox";
import moment from "moment/moment";

const LineChart = ({ data, loading, style = {} }) => {
  let chartData = {
    series: [
      {
        name: "Balance",
        data: data?.VALUES?.map((item, index) => {
          return {
            x: data?.TIME_STAMPS[index],
            y: item?.toFixed(2),
          };
        }),
      },
    ],
    stroke: {
      show: true,
      curve: "smooth",
      width: 3,
      dashArray: 0,
    },
    options: {
      chart: {
        type: "area",
        stacked: false,
        height: 350,
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
            customIcons: [],
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: "Balance",
        align: "left",
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            // return val?.toFixed(2);
            return Number(val).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        },
        title: {
          text: "USD",
        },
      },
      xaxis: {
        type: "datetime",
      },
      tooltip: {
        shared: false,
        x: {
          formatter: function (value) {
            return moment(value).format("DD MMM YY");
          },
        },
        //   {
        //   format: "MM/dd",
        // },
        y: {
          formatter: function (val) {
            // return (val / 1000000).toFixed(0)
            return val.toFixed(2);
          },
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
  };

  const containerStyle = {
    position: "relative",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(255,255,255, 0.5)",
  };

  return (
    <div style={{ ...containerStyle, ...style }}>
      {loading && (
        <div style={overlayStyle}>
          <Spin />
          <span>Loading balance chart...</span>
        </div>
      )}
      {!data && !loading && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "1rem",
            justifyContent: "center",
          }}
        >
          <EmptyBox useCase="analytic" size={60} />
          <span>No balance data available for this exchange.</span>
        </div>
      )}
      {data && (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="area"
          height={350}
          width={"100%"}
        />
      )}
    </div>
  );
};

export default LineChart;
